var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.00021C3.71 2.15021 2.5 4.18021 2.5 6.50021C2.5 8.82021 3.71 10.8502 5.53 12.0002C2.46 12.0002 0 9.54021 0 6.50021C0 5.04152 0.579463 3.64258 1.61091 2.61113C2.64236 1.57968 4.04131 1.00021 5.5 1.00021ZM17.07 2.50021L18.5 3.93021L2.93 19.5002L1.5 18.0702L17.07 2.50021ZM10.89 4.93021L9.41 4.00021L7.97 5.00021L8.39 3.30022L7 2.24021L8.75 2.12021L9.33 0.470215L10 2.10021L11.73 2.13021L10.38 3.26022L10.89 4.93021ZM7.59 8.54021L6.43 7.81021L5.31 8.59021L5.65 7.27022L4.56 6.44022L5.92 6.35021L6.37 5.06021L6.88 6.33021L8.24 6.36022L7.19 7.23021L7.59 8.54021ZM17 12.5002C17 13.9589 16.4205 15.3579 15.3891 16.3893C14.3576 17.4208 12.9587 18.0002 11.5 18.0002C10.28 18.0002 9.15 17.6002 8.24 16.9302L15.93 9.24021C16.6 10.1502 17 11.2802 17 12.5002ZM12.6 19.0802L15.37 17.9302L15.13 21.2802L12.6 19.0802ZM16.93 16.3802L18.08 13.6102L20.28 16.1502L16.93 16.3802ZM18.08 11.4202L16.94 8.64021L20.28 8.88021L18.08 11.4202ZM7.63 17.9302L10.4 19.0802L7.87 21.2702L7.63 17.9302Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.b58f79e7c0dbaa08ad724ba213ba043e.svg";
export { ForwardRef as ReactComponent };